<template>
	<v-container fluid>
		<v-row>
			<v-col>
				<v-card>
					<v-card-title
						class="d-flex align-center"
					>
						<v-icon
							icon="$store"
							start
						/>
						<translate>Products</translate>
						<v-spacer />
						<v-btn
							color="primary"
							variant="flat"
							prepend-icon="$plus"
							@click="goToCreate"
						>
							<translate>Add New Product</translate>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row no-gutters>
							<v-col>
								<v-select
									v-if="domains"
									v-model="domainFilter"
									variant="outlined"
									:items="domains"
									:label="`${$gettext('Domain')} ${$gettext('filter')}`"
									clearable
								/>
								<v-spacer />
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<model-table
									ref="productstable"
									:headers="headers"
									:items-per-page="-1"
									endpoint="/api/products"
									:filter="customeFilter"
									@items-retrieved="getFilterData($event)"
								>
									<template #item.id="{ item }">
										<a :href="`/bo/products/view?id=${item.id}`">
											{{ item.id }}
										</a>
									</template>
									<template #item.name="{ item }">
										<a :href="`/bo/products/view?id=${item.id}`">
											{{ item.name }}
										</a>
									</template>
								</model-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col>
				<a-b-test-list
					readonly
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import ModelTable from '../../../molecules/ModelTable.vue';
import ABTestList from '../../../molecules/ABTestList.vue';

/**
 * Component for /bo/products
 */

export default {
	name: 'ProductsOverview',
	components: {
		ABTestList,
		ModelTable
	},
	data () {
		return {
			domains: [],
			domainFilter: '',
		};
	},

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('ID'), sortable: true, value: 'id', filterable: true,
				},
				{
					title: this.$gettext('Name'), sortable: true, value: 'name', filterable: true,
				},
				{
					title: this.$gettext('Domain'), sortable: true, value: 'domain.name', filterable: true,
					filter: (value) => {
						return !this.domainFilter || value === this.domainFilter;
					}
				},
			];
		},
	},

	watch: {
		domainFilter () {
			this.$refs.productstable.index();
		}
	},

	methods: {
		/**
		 * Get data from the model table component and set our selects to have the unique set for each column
		 *
		 * @param {Array} e Array of objects from event containing the data fetched from the table
		 */
		getFilterData (e) {
			this.domains = [...new Set(e.map((item) => item.domain.name)), ];
		},

		/**
		 * Sets location to the product creation route
		 *
		 * @returns {void}
		 */
		goToCreate () {
			window.location.href = '/bo/products/new';
		},

		/**
		 *
		 * @param {object} item
		 * @returns {boolean}
		 */
		customeFilter (item) {
			return !this.domainFilter || item.domain.name === this.domainFilter;
		}
	}
};
</script>
